module.exports = __webpack_public_path__ + "components/home-header/static/header-1--medium@2x-890713f847d1cec1828fe1a484e14629.jpg";